import crypto from "crypto-js";
export default {
    criptografar(dadoParaCriptografar) {
        var criptografado = crypto.AES.encrypt(dadoParaCriptografar, "dados_do_hospede").toString();
        return criptografado
    },
    descriptografar(dadoParaDescriptografar) {
        var descriptografado = crypto.AES.decrypt(dadoParaDescriptografar, "dados_do_hospede").toString(crypto.enc.Utf8)
        return descriptografado
    }
}